<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit }" >
            <form @submit.prevent="handleSubmit(submit)" class="login-form" :class="{'loading': loading}">

                <ValidationProvider
                    :name="$t('E-mail')"
                    rules="required|email"
                    tag="div"
                    class="form-group"
                    v-slot="{ errors }">

                    <input v-model="loginForm.email" type="text" name="email" :placeholder="$t('E-mail')" class="form-control" :class="{ 'is-invalid': formErrors && formErrors.email }" autocomplete="on">
                    <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('Password')"
                    rules="required"
                    tag="div"
                    class="form-group"
                    v-slot="{ errors }">

                    <input v-model="loginForm.password" type="password" name="password" :placeholder="$t('Password')" class="form-control" :class="{ 'is-invalid': formErrors && formErrors.password }" autocomplete="on">
                    <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="alert alert-danger" v-if="formErrors && formErrors.email">
                    {{ formErrors.email[0] }}
                </div>
                <google-re-captcha-v3
                    v-model="loginForm.gRecaptchaResponse"
                    ref="captcha"
                    site-key="6LcYc50aAAAAAEO4r8anAbWprxsv_cbDse5KqSMP"
                    id="sign_up_id"
                    inline
                    action="sign_up"
                ></google-re-captcha-v3>
                <button type="submit" class="btn btn-primary mt-2" :disabled="loginFormSubmitting">
                    <span v-if="!loginFormSubmitting">{{ $t('Sign in') }}</span>
                    <span v-else>{{ $t('Sign in') + '...' }}</span>
                </button>
                <router-link :to="{ name: 'users.forgotPassword'}" class="btn text-white" :target="$route.name === 'rayline' ? '_blank' : ''">{{ $t('Forgot password') }}</router-link>
            </form>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import GoogleReCaptchaV3 from '../../components/googlerecaptchav3/GoogleReCaptchaV3';

export default {
    name: 'SignIn',
    components: {
        GoogleReCaptchaV3
    },

    data() {
        return {
            loginForm: {
                email: '',
                password: '',
                gRecaptchaResponse: null,
            },
            loginFormSubmitting: false,
            urlParameters: '',
            loading: false,
            captchaRef: null,
        }
    },

    computed: {

        ...mapGetters({
            formErrors: 'auth/formErrors',
            authenticated: 'auth/authenticated',
            permissions: 'auth/permissions'
        }),

    },

    mounted() {
        this.getUrlParameters();
    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn'
        }),

        setCaptchaRef() {
            let captcha = this.$refs.captcha

            if (captcha && !this.captchaRef) {
                this.captchaRef = captcha;
            }
        },

        async submit () {
            this.setCaptchaRef();

            this.loginFormSubmitting = true;
            this.loading = true;

            await this.signIn(this.loginForm);

            this.captchaRef.execute();

            // Set login form state
            this.loginFormSubmitting = false;
            this.loading = false;

            // Redirect Projects Index
            if (this.urlParameters && !this.formErrors) {
                this.$router.push(this.urlParameters);
            } else if ( this.$route.name === 'login' && !this.formErrors) {
                this.$router.push({ name: 'projects.index' });
            }

        },

        getUrlParameters() {
            const queryString = window.location.search;
            if (queryString) {
                const urlParams = new URLSearchParams(queryString);
                const redirectUrl = urlParams.get('redirect')
                this.urlParameters = redirectUrl;
            }
        },

    },


}
</script>
